import { Languages } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/contexts/I18nContext";

export function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useI18n();
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={toggle}
      className={`gap-1.5 rounded-full border-border bg-white/80 backdrop-blur ${className}`}
      data-testid="language-toggle"
      aria-label="Switch language"
    >
      <Languages className="h-4 w-4" />
      <span className="text-xs font-semibold tracking-wide">{lang === "es" ? "ES" : "EN"}</span>
    </Button>
  );
}
